export enum MarkerIconType {
    Default = 'default',
    MyPlace = 'myPlace',
    MieleExperienceCenter = 'center',
}

export default interface MarkerIcon {
    name: string;
    icon: string;
    order: number;
}